import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Componentss
import { BusinessAlertComponent } from '../business-alert/business-alert.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BusinessAlertComponent],
  exports: [BusinessAlertComponent]
})
export class BusinessAlertModule {}
